const _excluded = ["title", "content", "body", "className", "contentClassName", "bodyClassName", "footerClassName", "headerClassName", "contentRef", "skin", "cancelButtonDisabled", "primaryButtonDisabled", "primaryButtonLabel", "primaryButtonTestId", "primaryButtonTooltip", "primaryButtonLoading", "primaryButtonIntent", "primaryButtonFormId", "secondaryButtonLabel", "secondaryButtonTestId", "secondaryButtonLoading", "width", "height", "maxHeight", "textAlignCenter", "as", "contentPadding", "overflowContent", "onPrimaryButtonClick", "onSecondaryButtonClick", "onCloseButtonClick", "testId", "bi", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import cn from 'classnames';
import { BottomSheetContentLayout, useIsInBottomSheet } from "../BottomSheet";
import { Button } from "../Button";
import { CloseButton } from "../CloseButton";
import { useDevice } from "../Device";
import { Typography } from "../Typography";
import styles from "./ConfirmationModal.module.scss";
import { ConfirmationModalTestIds } from "./ConfirmationModal.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ConfirmationModal(props) {
  var _bi$primaryButton$nam, _bi$secondaryButton$n, _bi$primaryButton$nam2;
  const {
      title,
      content,
      body,
      className,
      contentClassName,
      bodyClassName,
      footerClassName,
      headerClassName,
      contentRef,
      skin = 'primary',
      cancelButtonDisabled,
      primaryButtonDisabled,
      primaryButtonLabel,
      primaryButtonTestId,
      primaryButtonTooltip,
      primaryButtonLoading,
      primaryButtonIntent,
      primaryButtonFormId,
      secondaryButtonLabel,
      secondaryButtonTestId,
      secondaryButtonLoading,
      width = 590,
      height,
      maxHeight,
      textAlignCenter = true,
      as = 'div',
      contentPadding = 'normal',
      overflowContent = false,
      onPrimaryButtonClick,
      onSecondaryButtonClick,
      onCloseButtonClick,
      testId,
      bi,
      style
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [loading, setLoading] = useState(false);
  const {
    isMobileDevice
  } = useDevice();
  const isInBottomSheet = useIsInBottomSheet();
  const Tag = as;
  const showFooter = !!secondaryButtonLabel || !!primaryButtonLabel;
  function handlePrimaryButtonClick(event) {
    if (!onPrimaryButtonClick) return;
    const result = onPrimaryButtonClick(event);
    if (result instanceof Promise) {
      setLoading(true);
      result.finally(() => setLoading(false));
    }
  }
  return isInBottomSheet ? /*#__PURE__*/_jsx(BottomSheetContentLayout, {
    contentGutter: "m",
    contentClassName: styles.bottomSheetContent,
    header: {
      title,
      paddingBottom: 8
    },
    footer: {
      paddingTop: 8,
      // Not secondary button on purpose. Its usually a cancel button and we already have a close button.
      primaryAction: primaryButtonLabel ? {
        text: primaryButtonLabel,
        onClick: handlePrimaryButtonClick,
        disabled: primaryButtonDisabled,
        intent: primaryButtonIntent,
        testId: primaryButtonTestId !== null && primaryButtonTestId !== void 0 ? primaryButtonTestId : ConfirmationModalTestIds.primaryButton,
        loading: primaryButtonLoading || loading,
        tooltip: primaryButtonTooltip ? {
          placement: 'top',
          title: primaryButtonTooltip
        } : undefined,
        bi: {
          name: (_bi$primaryButton$nam = bi === null || bi === void 0 ? void 0 : bi.primaryButton.name) !== null && _bi$primaryButton$nam !== void 0 ? _bi$primaryButton$nam : '',
          data: bi === null || bi === void 0 ? void 0 : bi.primaryButton.data
        }
      } : undefined
    },
    children: content
  }) : /*#__PURE__*/_jsxs(Tag, _objectSpread(_objectSpread({
    className: cn(styles.root, className)
  }, rest), {}, {
    "data-testid": testId !== null && testId !== void 0 ? testId : ConfirmationModalTestIds.root,
    style: _objectSpread({
      width,
      height,
      maxHeight
    }, style),
    children: [/*#__PURE__*/_jsxs("div", {
      className: cn(styles.header, styles["".concat(skin, "Skin")], headerClassName),
      children: [/*#__PURE__*/_jsx(Typography, {
        weight: "bold",
        variant: "h6",
        testId: ConfirmationModalTestIds.title,
        children: title
      }), /*#__PURE__*/_jsx(CloseButton, {
        skin: "transparent",
        onClick: onCloseButtonClick || onSecondaryButtonClick,
        className: styles.closeButton,
        testId: ConfirmationModalTestIds.closeButton,
        disabled: !!cancelButtonDisabled
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: cn(styles.body, {
        [styles.infiniteBodyPadding]: overflowContent
      }, bodyClassName),
      children: [body, /*#__PURE__*/_jsx("div", {
        ref: contentRef,
        "data-testid": ConfirmationModalTestIds.content,
        className: cn(styles.content, {
          [styles.contentAlignmentCenter]: textAlignCenter,
          [styles.contentSmallPadding]: contentPadding === 'small',
          [styles.mobile]: isMobileDevice
        }, contentClassName),
        children: typeof content === 'string' ? /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph1",
          children: content
        }) : content
      })]
    }), showFooter && /*#__PURE__*/_jsx("div", {
      className: cn(styles.footer, footerClassName),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.actions,
        children: [secondaryButtonLabel && /*#__PURE__*/_jsx(Button, {
          size: "medium",
          skin: skin === 'transparent' ? 'primaryOutline' : "".concat(skin, "Outline"),
          bi: {
            name: (_bi$secondaryButton$n = bi === null || bi === void 0 ? void 0 : bi.secondaryButton.name) !== null && _bi$secondaryButton$n !== void 0 ? _bi$secondaryButton$n : '',
            data: bi === null || bi === void 0 ? void 0 : bi.secondaryButton.data
          },
          onClick: onSecondaryButtonClick,
          testId: secondaryButtonTestId !== null && secondaryButtonTestId !== void 0 ? secondaryButtonTestId : ConfirmationModalTestIds.secondaryButton,
          loading: secondaryButtonLoading,
          type: "button",
          children: secondaryButtonLabel
        }), primaryButtonLabel && /*#__PURE__*/_jsx(Button, {
          type: "submit",
          size: "medium",
          form: primaryButtonFormId,
          skin: skin === 'transparent' ? 'primary' : "".concat(skin),
          intent: primaryButtonIntent,
          bi: {
            name: (_bi$primaryButton$nam2 = bi === null || bi === void 0 ? void 0 : bi.primaryButton.name) !== null && _bi$primaryButton$nam2 !== void 0 ? _bi$primaryButton$nam2 : '',
            data: bi === null || bi === void 0 ? void 0 : bi.primaryButton.data
          },
          onClick: handlePrimaryButtonClick,
          testId: primaryButtonTestId !== null && primaryButtonTestId !== void 0 ? primaryButtonTestId : ConfirmationModalTestIds.primaryButton,
          loading: primaryButtonLoading || loading,
          disabled: primaryButtonDisabled,
          tooltip: primaryButtonTooltip ? {
            placement: 'top',
            title: primaryButtonTooltip
          } : undefined,
          children: primaryButtonLabel
        })]
      })
    })]
  }));
}